// import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

// import Editor from './components/editor';
// import Image from './components/image';
// import App from './components/app';

import './css/editable.css';
import './css/index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <div style={{margin: '10px', padding: '10px', borderRadius: '6px', border: 'solid black 1px'}}>
      <h1>Until next time!</h1>
      <p>This site is migrating to a new one, under a different name and personality. I really appreciate anyone visiting this site over
      the years, I've had a lot of fun working on it and sharing what I've seen with everyone. All the photos and videos I've taken will come with
      me to this new identity, so they will be available again. I hope you can find me!</p>
      <img src='/signature-logo-white-192.png' width={'192px'} height={'192px'} />
    </div>
  </>
);